<template>
  <!-- 产品服务-车镇车源 -->
  <div class="box czcy">
    <div v-if="!isM" class="czcy_banner bgimg">
      <div class="cz_bg">
        <div class="czb_box">
          <h4>车镇车源APP</h4>
          <div>
            车镇车源APP，从新车车源信息分享，切入B2B撮合交易，实现智能寻车、汽车物流、汽车保险等一站式新车B2B产业链服务，打造产业+互联网的新生态。
          </div>
          <div class="cz_down">
            <div class="czd_l">
              <a href="https://c.chezhency.com" target="_blank">Android下载</a>
              <a
                href="https://itunes.apple.com/cn/app/che-zhen-che-yuan/id1022244878?l=en&mt=8"
                target="_blank"
                >App Store下载</a
              >
            </div>
            <img :src="picUrl + 'down_cz.png'" alt="下载车镇车源" />
          </div>
        </div>
      </div>
    </div>

    <div v-if="isM" class="czcym_banner">
      <div class="czb_box">
        <h4>车镇车源APP</h4>
        <div class="cz_des">
          车镇车源APP，从新车车源信息分享，切入B2B撮合交易，实现智能寻车、汽车物流、汽车保险等一站式新车B2B产业链服务，打造产业+互联网的新生态。
        </div>
        <div class="cz_down">
          <a href="https://c.chezhency.com">Android下载</a>
          <a
            href="https://itunes.apple.com/cn/app/che-zhen-che-yuan/id1022244878?l=en&mt=8"
            >App Store下载</a
          >
        </div>
        <img :src="picUrl + 'bannerczm.png'" alt="车镇车源" />
      </div>
    </div>

    <div class="cz1">
      <div class="min_box">
        <ul class="cz1_top cz1warp">
          <li
            v-for="(item, index) in arr"
            :key="item.id"
            @mouseover="czhpver(index)"
          >
            <div>
              <img
                :src="picUrl + 'cz' + (index + 1) + '.png'"
                :alt="item.tit"
              />
              <span>{{ item.tit }}</span>
            </div>

            <p v-if="decIdx == index" class="cz1_de">
              {{ item.dec }}
            </p>
          </li>
        </ul>
      </div>
    </div>

    <div class="cz2">
      <div class="min_box">
        <div class="cz2_box">
          <div>海量车源</div>
          <p v-if="!isM">
            80万+在线真实车源 <br />
            实时行情，一手掌握
          </p>
          <p v-if="isM">80万+在线真实车源 实时行情，一手掌握</p>
        </div>
        <img v-if="!isM" :src="picUrl + 'czcy1.png'" alt="海量车源" />
        <img v-if="isM" :src="picUrl + 'czcym1.png'" alt="海量车源" />
      </div>
    </div>

    <div v-if="!isM" class="znxc bgimg"></div>
    <img v-if="isM" class="znxc" :src="picUrl + 'czcym.jpg'" alt="" />
  </div>
</template>

<script>
export default {
  name: "czcy",
  data() {
    return {
      picUrl: this.$root.picUrl,
      arr: [
        {
          tit: "4S店车源",
          dec: "80万+在线车源，可按车型、价格、颜色、地域等精准筛选",
        },
        {
          tit: "平行进口车",
          dec: "平行进口车市场专区，车辆配置详情一应俱全",
        },
        {
          tit: "新能源",
          dec: "新能源车市场专区，车辆配置详情应有尽有",
        },
        {
          tit: "同城现车",
          dec: "区域车源共享，库存车源就近调拨",
        },
        {
          tit: "自营现车",
          dec: "集采低价优质车源，为车商降低采购成本",
        },
        {
          tit: "智能寻车",
          dec: "一键呼叫，坐享底价",
        },
//        {
//          tit: "垫款提车",
//          dec: "供应链金融服务，包含采购/展车/库存/4S店提车融资",
//        },
//        {
//          tit: "秒个贷",
//          dec: "解决C端多样化分期购车需求",
//        },
//        {
//          tit: "定金担保",
//          dec: "保障买卖双方的利益，让买卖双方更快达成交易",
//        },
        {
          tit: "物流服务",
          dec: "可视化物流，一键下单，24小时实时监控，点对点接送",
        },
        {
          tit: "同行圈",
          dec: "10万车商朋友圈，不仅聊生意还能交朋友",
        },
        {
          tit: "更多服务",
          dec: "还有车型资料库，VIN识别、进口VIN等功能",
        },
      ],
      decIdx: 0,
      isM: false,
    };
  },
  created() {
    this.isM = JSON.parse(sessionStorage.getItem("isM"));
    this.dec = this.arr[0].dec;
  },
  methods: {
    czhpver(idx) {
      this.decIdx = idx;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Proservices/czcy.vue